export default {
  // Componente visual - sem textos traduzíveis estáticos
}
